module.exports = "<div gw-loader=\"loadingPromise\">\r\n\r\n    <iframe\r\n            class=\"gw-gateway-report-frame\"\r\n            frameborder=\"0\"\r\n            allowtransparency=\"true\"\r\n            scrolling=\"auto\">\r\n    </iframe>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/directives/templates/report-frame.html
// module id = 766
// module chunks = 0